import { useState, useCallback } from 'react';
import { ViewMode } from '@/types';

/**
 * 뷰 모드 (카드/테이블) 관리 훅
 * 로컬스토리지에 자동 저장됩니다.
 */
export const useViewMode = (storageKey: string, defaultView: ViewMode = 'card') => {
  const [view, setView] = useState<ViewMode>(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      return (stored === 'card' || stored === 'table') ? stored : defaultView;
    } catch {
      return defaultView;
    }
  });

  const handleViewChange = useCallback((newView: ViewMode) => {
    setView(newView);
    try {
      localStorage.setItem(storageKey, newView);
    } catch (error) {
      console.error('Failed to save view mode to localStorage:', error);
    }
  }, [storageKey]);

  return { view, setView: handleViewChange };
};

